import React from 'react';

interface UserInputTableProps {
    assetName: string;
    country: string;
    user: string;
    uploadTime: string;
    id: string;
    brand: string;
}

const UserInputTable: React.FC<UserInputTableProps> = ({
    assetName,
    country,
    brand,
    uploadTime,
    id,
}) => {
    const runInfo = (
        <>
            {/* <div className="user-input-row">
                <div className="user-input-label">Uploaded by</div>
                <div className="user-input-value">{user}</div>
            </div> */}
            <div className="user-input-row">
                <div className="user-input-label">Upload Time</div>
                <div className="user-input-value">{uploadTime}</div>
            </div>
            <div className="user-input-row">
                <div className="user-input-label">ID</div>
                <div className="user-input-value">{id}</div>
            </div>
        </>
    );
    const userInput = (
        <>
            <div className="user-input-row">
                <div className="user-input-label">Asset Name</div>
                <div className="user-input-value">{assetName}</div>
            </div>
            <div className="user-input-row">
                <div className="user-input-label">Brand</div>
                <div className="user-input-value">{brand}</div>
            </div>
            <div className="user-input-row">
                <div className="user-input-label">Market</div>
                <div className="user-input-value">{country}</div>
            </div>
        </>
    );
    return (
        <>
            <div className="rules-check-controls">
                <h3>Asset Information</h3>
            </div>

            <div className="user-input-table">
                <div className="user-input-column">
                    {runInfo}
                    {userInput}
                </div>
            </div>
        </>
    );
};

export default UserInputTable;
